import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css';

function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  return (
    <div className="navbar">
      {/* Logo with ® symbol */}
      <div className="navbar-logo">
        <div className="logo-container">
          <img
            src="logo.PNG"  // Replace with your logo path
            alt="Logo"
            className="navbar-logo-image"
          />
          <span className="trademark-symbol">®</span>
        </div>
      </div>

      {/* Hamburger Icon */}
      <div className="hamburger" onClick={toggleMenu}>
        <div className="bar"></div>
        <div className="bar"></div>
        <div className="bar"></div>
      </div>

      {/* Navigation Links */}
      <div className={`navbar-links ${isMenuOpen ? 'active' : ''}`}>
        <Link to="/" className="navbar-link" onClick={toggleMenu}>
          Home
        </Link>
        <Link to="/practicearea" className="navbar-link" onClick={toggleMenu}>
          Practice Areas
        </Link>
        <Link to="/ourteam" className="navbar-link" onClick={toggleMenu}>
          Our Team
        </Link>
        <Link to="/blog" className="navbar-link" onClick={toggleMenu}>
          Blogs
        </Link>
        <Link to="/contact" className="navbar-link" onClick={toggleMenu}>
          Contact
        </Link>
      </div>
    </div>
  );
}

export default Navbar;
